import React, { useEffect, useState } from 'react'
import { Link, NavLink, useLocation, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from "yup";


import ExpandableAllTask from '../Components/ExpandableAllTask';
import TaskLayout from '../TaskLayout';
import axiosInstance from '../../../../Services/axiosCommon';
import { GetAccess } from '../../../../Components/Utils/roles';
import MobileTask from '../../../Mobile/Task/MobileMyTask';
import Pagination from '../../../../Components/Utils/Pagenation';
import { NuDate } from '../../../../Components/Utils/Input';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import SearchBar from '../../../../Components/Utils/SearchBar';
import { CancelButton, FilterButton, SubmitButton } from '../../../../Components/Utils/Buttons';

import UseGetDataSearchByPro from '../../../../Components/Hooks/useFetchDataByPRO';
import { useToast } from '../../../../Components/Others/ToastServices';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';


function AllTask() {
 
  const { projectId } = useParams();
  const location = useLocation();
  // const { number, updateNumber } = useNumber();
  const projectTask = location?.state?.projectNum || "";
  const [filterOpen, setFilterOpen] = useState(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [dataCount, setDataCount] = useState(20);
  const [totalTasks, setTotalProject] = useState(0);
  // const [searchQuery, setSearchQuery] = useState("");
  const [projectList, setProjectList] = useState([]);
  // const [data, setData] = useState([]);
  const [status, setStatus] = useState([])
  const [priority, setPriority] = useState([]);
  const [firstProject, setFirstProject] = useState("");
  const [isFilter,setIsFilter]= useState(false);
  const [notFirst,setNotFirst]=useState(false);
  const [members,setMembers] =useState([]);
  console.log("ccc",firstProject);
  const [filterData,setFilterData]= useState({
    startDate:"",
    endDate:"",
    status: "",
    priority: "",
    assignedTo: ""
  });
  const [afterFilter,setAfterFilter]= useState({})
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });


  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);  

  const toast = useToast();
  const currentPage= location.state?.currentPage
const searchQuery= location.state?.searchQuery
const [page, setPage] = useState(currentPage||1)
const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
const [filter, setFilter] = useState(false);
const [showFilterDialog, setShowFilterDialog] = useState(false);

const [filterProps, setFilterProps] = useState({
  startDate:"",
  endDate:"",
  status: "",
  priority: "",
  assignedTo: ""
});
const [params, setParams] = useState({
page: page,
per_page: pageCount,
search:searchQuery||"",
startDate:"",
endDate:"",
status: "",
priority: "",
assignedTo: ""
});
const clearFilter = ()=> {
setParams({...params, startDate:"",
  endDate:"",
  status: "",
  priority: "",
  assignedTo: ""
})
formik.values.startDate=""
formik.values.endDate=""
formik.values.status=""
formik.values.assignedTo=""

formik.values.priority=""


 setFilter(false)
}

const formik = useFormik({
enableReinitialize: true,
initialValues: filterProps,
validateOnChange: false,
validateOnBlur: false,
validationSchema: yup.object({
 // email: yup.string().required('Email is required!'),
}),
onSubmit: async (value, { resetForm }) => {
 console.log("ffff",value);
 setParams({...params,priority:value.priority, assignedTo:value.assignedTo,status:value.status,endDate:value.endDate,startDate:value.startDate})
 closeFilterDialog();
 setFilter(true)
 setFilterProps({
  startDate:"",
  endDate:"",
  status: "",
  priority: "",
  assignedTo: ""
 });
}
})

const { data, totalCount, getData,dataLoading } = UseGetDataSearchByPro( '/mytask/byUser/members_all_tasks',params);

useEffect(()=>{
setParams({...params,page:page,per_page:pageCount})
},[page,pageCount])

const closeFilterDialog = () => {
 setShowFilterDialog(false);
};

//   // async function getProject() {
//   //   await axiosInstance
//   //     .get(`/Team/getUserProjectId`)
//   //     .then(async (res) => {
//   //       if(number!=0){
//   //         setFirstProject(number)
//   //       }else if (projectTask) {
//   //         setFirstProject(projectTask);
//   //       } else {
//   //         res?.data?.data[0] && setFirstProject(res?.data?.data[0]?.ProjectId)
//   //         updateNumber(res?.data?.data[0]?.ProjectId)

//   //       }
//   //       let list = res?.data?.data || [];
//   //       let finalData = [];
//   //       (await res?.data?.data) &&
//   //         list.map((item, idx) => {
//   //           finalData.push({
//   //             value: item.ProjectId,
//   //             label: item.ProjectName,
//   //           });
//   //         });
//   //       setProjectList(finalData);
//   //     })
//   //     .catch((error) => {
//   //       console.log(error);
//   //     });
//   // }

//   const getStatus = () =>{
//     axiosInstance.get(`/Metadata/taskstatus`).then(res=>{
//         let data = res.data?.data?.keyValues;
//         let tempData = [];
//         data.forEach((item) => {
//           let tempObject = { value: item, label: item };
//           tempData.push(tempObject);
//         });
//         res.data?.data?.keyValues && setStatus(tempData);
//     }).catch(error=>{
//         console.log("dddd");
//     })
// }

// const getPriority = () =>{
//   axiosInstance.get(`/Metadata/taskpriority`).then(res=>{
//       let data = res.data?.data?.keyValues;
//       let tempData = [];
//       data.forEach((item) => {
//         let tempObject = { value: item, label: item };
//         tempData.push(tempObject);
//       });
//       res.data?.data?.keyValues && setPriority(tempData);
//   }).catch(error=>{
//       console.log("dddd");
//   })
// }

// const getMembers =(proId)=>{
//   // console.log('getmember');
//   axiosInstance.get(`/DropDown/team_member/${proId}`).then((response)=>{
//    console.log("hhh",response.data.data)
//    let FinalData = []
//    let status = response.data.data;
//    status.forEach((item) => {
//     console.log("ddd",item.memberId);
//      let tempObject = { value: item.userId, label: item.Name };
//      FinalData.push(tempObject);
//    });
//    response.data.data && setMembers(FinalData);

//   }).catch((error)=>{console.log(error);});
// };

// console.log("vvv",members);

//   useEffect(() => {
//     getStatus()
//     // getProject();
//     getPriority();
//     getMembers();
//   }, []);

//   function SearchData(e) {
//     setNotFirst(true)
//     e.preventDefault();
//     if (searchQuery != "") {
//       axiosInstance
//         .get(`/mytask/byUser/members_all_tasks/${projectId}?page=${pageIndex}&per_page=${dataCount}`,{params:{search:`${searchQuery}`}})
//         .then((res) => {
//           setData(res.data?.data);
//         setTotalProject(res.data?.total_records)

//         })
//         .catch((err) => console.log(err));
//     } else {
//       getTask(firstProject);
//     }
//   }

//   function SearchPageDate(){
//     axiosInstance
//     .get(`/mytask/byUser/members_all_tasks/${projectId}?page=${pageIndex}&per_page=${dataCount}`,{params:{search:`${searchQuery}`}})
//     .then((res) => {
//       setData(res.data?.data);
//       setTotalProject(res.data?.total_records)

//     }).catch((err) => console.log(err))
//   }

//   // function handleProjectChange(e) {
//   //   setFirstProject(e);
//   //   updateNumber(e);
//   // }

//   function getTask(x) {
//     axiosInstance
//       .get(`/mytask/byUser/members_all_tasks/${x}?page=${pageIndex}&per_page=${dataCount}`)
//       .then((res) => {
//         setData(res.data?.data);
//         setTotalProject(res.data?.total_records)
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   }

//   useEffect(() => {
//     if (searchQuery == "" &&notFirst) {
//       getTask(projectId);
//     }
//   }, [searchQuery]);



//   useEffect(() => {
//     if (projectTask) {
//       setFirstProject(projectTask);
//     }
//   }, [projectTask]);




//   const formik = useFormik({
//     enableReinitialize: true,
//     initialValues: filterData,
//     validateOnChange: false,
//     validateOnBlur: false,
//     validationSchema: yup.object({
//       mobileNo: yup
//         .string()
//         .matches(
//           /^((\\[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
//           "Enter Valid Mobile Number"
//         )
//         .min(10, "Invalid Mobile Number")
//         .max(10, "Invalid Mobile Number"),
//     }),
//     onSubmit: async (value, { resetForm }) => {
//       setAfterFilter(value)
//       setIsFilter(true)
//       axiosInstance
//       .get(`/mytask/byUser/members_all_tasks/${firstProject}?page=${pageIndex}&per_page=${dataCount}`,{params:{status:`${value.status}`,startDate:`${value.startDate}`,endDate:`${value.endDate}`,priority:`${value.priority}`,assignedTo:`${value.assignedTo}`}})
//       .then((res) => {
//         setFilterOpen(false)
//         setData(res.data?.data);
//         setTotalProject(res.data?.total_records)

//       })
//       .catch((error) => {
//         console.log(error);
//       });
//     },
//   });

//   function FilterPage(){
//     axiosInstance
//       .get(`/mytask/byUser/members_all_tasks/${projectId}?page=${pageIndex}&per_page=${dataCount}`,{params:{status:`${afterFilter.status}`,startDate:`${afterFilter.startDate}`,endDate:`${afterFilter.endDate}`,priority:`${afterFilter.priority}`,assignedTo:`${afterFilter?.assignedTo}`}})
//       .then((res) => {
//         setData(res.data?.data);
//         setTotalProject(res.data?.total_records)
//       }).catch(err=>console.log(err))
//   }


//   function ClearFilter(){
//     formik.resetForm({})
//     getTask(projectId);
//     setIsFilter(false)
//   }

//   useEffect(()=>{
//    if(isFilter){
//     FilterPage();
//    }else if(searchQuery !=""){
//       SearchPageDate();
//     }else{
//     getTask(projectId)
//     }
//   },[pageIndex,dataCount])

//   useEffect(() => {
//     // if (firstProject) {
//       getMembers(projectId);
//     // }
//   }, []);

//   console.log("qqqqqq",data);
  return (
    <>
  <div className='w-full h-full px-4 py-2'>
      <div className='w-full flex justify-between items-center'>
        <Breadcrumb
          items={[
            { name: "All Task" },

            // {
            //   // name: "Items",
            //   // link: "/products/items"
            // },

          ]} />
        <div className=' flex gap-2'>
        <SearchBar
              handleChange={(e) =>{
                setParams({ ...params, search: e.target.value, page:1 });
                setPage(1)
              }}
              value={params.search||searchQuery}
            /> <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
          {filter && <FilterButton  handleClick={()=>clearFilter()} label='Clear'/>}
        
          {/* {GetRole() && <ImportButton handleClick={handleImportClick} />}
          {GetAccess("items_create") &&<Link to="/products/items/create"><CreateButton label='Product' /></Link>} */}
        </div>
      </div>
{
screenSize.width<="786"?<MobileTask Data={data} getData={getData} firstProject={firstProject}  />:
<div className=" w-full h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
<div className="h-[calc(100vh-180px)] overflow-y-auto">
<table className="table-auto w-full" style={{ border: 'none', borderCollapse: 'collapse' }}>
  <thead className=" w-full bg-white p-3 mt-4">
    <tr className="text-xs  font-medium   py-3 border-b ">
      {header.map((header, i) => (
        <th className={`py-3 ${header.width} ${header?.isLeft?"text-left":"text-center"} font-medium text-xs 2xl:text-sm text-[#4F4768]`} key={i} style={{ border: 'none', borderCollapse: 'collapse' }}>
          {header.headone}
        </th>
      ))}
    </tr>
  </thead>
  <tbody className=''>
    {
      data.map((item, i) => (

        <ExpandableAllTask firstProject={firstProject} item={item} key={i} getData={getData} projectId={projectId}  />
                   ))
    }
  </tbody>
</table>
</div>


<div className=" h-6 my-2">
{/* <Pagination
  total={totalTasks}
  pageIndex={pageIndex}
  setPageIndex={setPageIndex}
  dataCount={dataCount}
  setDataCount={setDataCount}
/> */}
 <Pagination
              total={totalTasks}
              pageIndex={pageIndex}
              setPageIndex={setPageIndex}
              dataCount={dataCount}
              setDataCount={setDataCount}
            />
</div>
</div>
}
    {/* </TaskLayout> */}
    {showFilterDialog && (
             
             
             <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
               <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                 <h2 className="text-xl mb-4">Filter All Task</h2>
                 <form onSubmit={formik.handleSubmit}>
                     <div className="flex flex-col mb-4">
                                      <p className="py-2 px-6 text-m">Date</p>
                                      <div className="flex justify-between  w-full ">
                                      <NuDate
              label="Start Date From"
              formik={formik}
              placeholder="Choose"
              name="startDate"
              width=" w-full"
            />
          
            <NuDate
              label="End Date To"
              formik={formik}
              placeholder="Choose"
              name="endDate"
              width=" w-full"
            />
                              </div> 
                              <FormikSelectTwo
              label="Assigned To"
              Options={members}
              formik={formik}
              placeholder="Choose"
              name="assignedTo"
              width=" w-full"
            />
             <FormikSelectTwo
              label="Priority"
              Options={priority}
              formik={formik}
              placeholder="Choose"
              name="priority"
              width=" w-full"
            /> 
            <FormikSelectTwo
              label="Status"
              Options={status}
              formik={formik}
              placeholder="Choose"
              name="status"
              width=" w-full"
            />
         
                    </div>
                   <div className="flex justify-end gap-2">
                     <CancelButton handleClick={closeFilterDialog} />
                     <SubmitButton name='Apply' />
                   </div>
                  </form> 
               </div>
             </div>
           )}
      {/* <Modal
        open={filterOpen}
        title={"Filter All Tasks"}
        width={"50%"}
        className="my-modal"
        centered
        onCancel={()=>setFilterOpen(false)}
        footer={[]}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className=" w-full flex flex-wrap">
            <FormikSelectTwo
              label="Assigned To"
              Options={members}
              formik={formik}
              placeholder="Choose"
              name="assignedTo"
              width=" w-full"
            />
            <FormikSelectTwo
              label="Status"
              Options={status}
              formik={formik}
              placeholder="Choose"
              name="status"
              width=" w-full"
            />
            <NuDate
              label="Start Date From"
              formik={formik}
              placeholder="Choose"
              name="startDate"
              width=" w-full"
            />
          
            <NuDate
              label="End Date To"
              formik={formik}
              placeholder="Choose"
              name="endDate"
              width=" w-full"
            />
            <FormikSelectTwo
              label="Priority"
              Options={priority}
              formik={formik}
              placeholder="Choose"
              name="priority"
              width=" w-full"
            />           
            <Button
              htmlType="submit"
              size="large"
              className="w-11/12 bg-[#048178] text-white  mx-auto"
            >
              Filter 
            </Button>
          </div>
        </form>
      </Modal> */}
      </div>
    </>
  )
}

export default AllTask;

const header = [
  {
    headone: "",
    width: "w-[3%] ",
    // isLeft: true,
  },
  {
    headone: "Activity",
    width: "w-[23%] ",
    isLeft: true,
  },
  {
    headone: "Assigned to",
    width: "w-[15%]",
    isLeft: true,
  },
  {
    headone: "Start Date",
    width: "w-[10%]",
  },
  {
    headone: "Due Date",
    width: "w-[10%]",
  },
  {
    headone: "Duration",
    width: "w-[10%]",
  },
  {
    headone: "Priority",
    width: "w-[10%]",
  },
  {
    headone: "Status",
    width: "w-[10%]",
  },
  {
    headone: " ",
    width: "w-[5%]",
  },
  {
    headone: "Action",
    width: "w-[4%]",
    isLeft: true,
  }
];